import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { ApiVersionModel } from "@webapp/core/abstracts/models/api-version.model";
import { BaseApiService } from "@webapp/core/abstracts/services/base-api.service";
import { APP_CONFIG, IAppConfig } from "@webapp/core/app-config/models/app-config.models";
import { Goal, GoalDTO } from "../models/goal.models";
import { GoalsState } from "./goals-state.service";

@Injectable({
  providedIn: "root",
})
export class GoalsApiService extends BaseApiService<Goal, GoalDTO, GoalsState> {
  constructor(httpClient: HttpClient, @Inject(APP_CONFIG) appConfig: IAppConfig, state: GoalsState) {
    // TODO: Migrate other methods from goal.service.ts to GoalsApiService when they are going to be used.
    // TODO: Add switchMap() for applyColoringToGoalCollection
    super("goals", { ...new ApiVersionModel("v1"), getAll: "v2", get: "v2" }, httpClient, appConfig, state);
  }
}
